import { useCallback } from "react";
import PropTypes from "prop-types";
import "./MerchandisingFilters.scss";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MerchandisingFiltersItem from "app/pages/Merchandising/MerchandisingFilters/MerchandisingFiltersItem";
import {
	sendTagOnMerchandisingProductsFilter,
	sendTagOnMerchandisingProductsFilterRemove,
} from "app/utils/analytics";
import {
	setMerchProductsFilter,
	unsetMerchProductsFilter,
} from "app/pages/Merchandising/merchandisingActionCreators";

const MerchandisingFilters = ({
	merchandisingTopics,
	setMerchProductsFilter,
	unsetMerchProductsFilter,
	onFilterSelect,
	activeFilter,
}) => {
	const handleFilterSelect = useCallback(
		merchandisingTopic => {
			if (activeFilter === merchandisingTopic) {
				unsetMerchProductsFilter();
				onFilterSelect(undefined);
				sendTagOnMerchandisingProductsFilterRemove(merchandisingTopic);
			} else {
				setMerchProductsFilter(merchandisingTopic);
				onFilterSelect(merchandisingTopic);
				sendTagOnMerchandisingProductsFilter(merchandisingTopic);
			}
		},
		[onFilterSelect, merchandisingTopics]
	);

	return (
		<div className="merchandising-filters" data-testid="merchandising-filters">
			{merchandisingTopics.map((merchandisingTopic, index) => {
				return (
					<MerchandisingFiltersItem
						key={index}
						active={activeFilter === merchandisingTopic}
						onFilterSelect={handleFilterSelect}
						label={merchandisingTopic}
					/>
				);
			})}
		</div>
	);
};

MerchandisingFilters.propTypes = {
	merchandisingTopics: PropTypes.arrayOf(PropTypes.string),
	setMerchProductsFilter: PropTypes.func,
	unsetMerchProductsFilter: PropTypes.func,
	onFilterSelect: PropTypes.func,
	activeFilter: PropTypes.string,
};

MerchandisingFilters.defaultProps = {
	merchandisingTopics: [],
	onFilterSelect: () => {},
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ setMerchProductsFilter, unsetMerchProductsFilter }, dispatch);
};

export default connect(null, mapDispatchToProps)(MerchandisingFilters);
